import { AuditCard } from "@/pages/a7/Audit/AuditCard";
import i18n from "@/i18n";
import { Button, Link } from "@heroui/react";
import { useParams } from "react-router-dom";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

import { EditCardWrapper } from "@/features/Edit/EditCardWrapper.tsx";
import { a7FIATimeSerieFilesEdit } from "@/pages/a7/EditForms/a7FIATimeSerieFilesEdit.tsx";
import { getTimeSerieFilesAuditColumns } from "./columns";

const table_name = "a7_fia_time_serie_files";

export const A7FIATimeSerieFilesEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n: i18nClient } = useTranslation(["tables", "common"]);
  const auditColumns = useMemo(
    () => getTimeSerieFilesAuditColumns(t),
    [t, i18nClient.language],
  );

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full bg-gray-50">
      <div className="flex flex-col gap-10 p-10">
        <div className="flex">
          <div className="flex-grow flex justify-center">
            <EditCardWrapper
              client={"a7"}
              id={Number(id)}
              {...a7FIATimeSerieFilesEdit}
              disable_translations_request={true}
            />
          </div>
          <div>
            <Button
              href={toWorkspacePath(
                `/admin/a7-fia/a7_fia_compositions?file_id_equals=${id}`,
              )}
              variant="bordered"
              color="primary"
              showAnchorIcon
              as={Link}
              radius="full"
              className="bg-white border-1 border-neutral-300 shadow-xl"
            >
              {t("a7_fia_compositions.title", {
                ns: "tables",
                defaultValue: "Compositions",
              })}
            </Button>
          </div>
        </div>
        <AuditCard
          client={"a7"}
          id={Number(id)}
          name={table_name}
          audit_columns={auditColumns}
        />
      </div>
    </div>
  );
};
